import {
  SET_ACCESS_UID,
  SET_AUTHENTICATED,
  SET_AUTHENTICATING,
  SET_REFRESH_TOKEN_EXPIRED,
  SET_TOKEN,
  SET_TOKENS,
} from "common/reducers/auth.actions";
import type { RootActions, RootState } from "common/reducers/index";
import { Nullable } from "common/types";
import { Record } from "immutable";

export const AuthStateRecord = Record({
  token: null as Nullable<string>,
  refreshToken: null as Nullable<string>,
  authenticating: false,
  refreshTokenExpired: false,
  accessUid: null as Nullable<string>,
  authenticated: null as Nullable<boolean>,
});

export const model = "auth";
export const initialState = AuthStateRecord();
export type AuthState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  switch (action.type) {
    case SET_TOKENS:
      return state
        .setIn([model, "token"], action.payload.token)
        .setIn([model, "refreshToken"], action.payload.refreshToken);
    case SET_TOKEN:
      return state.setIn([model, "token"], action.payload);
    case SET_ACCESS_UID:
      return state.setIn([model, "accessUid"], action.payload.uid);
    case SET_AUTHENTICATING:
      return state.setIn([model, "authenticating"], action.payload);
    case SET_REFRESH_TOKEN_EXPIRED:
      return state.setIn([model, "refreshTokenExpired"], action.payload);
    case SET_AUTHENTICATED:
      return state.setIn([model, "authenticated"], action.payload);
    default:
      return state;
  }
};
